import { useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { IStyles } from '@interfaces/styles';
import { ScreenSizes } from '@interfaces';

const HORIZONTAL_SPACE = 40;
const VERTICAL_SPACE = 32;

const HORIZONTAL_SPACE_MOBILE = 20;
const VERTICAL_SPACE_MOBILE = 16;

export const useStyles = (): IStyles => {
  const { breakpoints } = useTheme();

  return {
    root: {
      boxShadow: 'none',
      borderRadius: '99px',
      width: 'auto',
      padding: '7px',
      background: colors.black_99,
      backdropFilter: 'blur(12px)',
      border: '1px solid rgba(255, 255, 255, 0.25)',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '7px',
      },
    },
    rootSecondary: {
      boxShadow: 'none',
      width: 'auto',
      p: 0,
      m: 0,
    },
    section: {
      display: 'flex',
      gap: '12px',
      flexDirection: 'row',
      alignItems: 'center',
    },
    sectionSmall: {
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        gap: '4px',
      },
    },
    divider: {
      backgroundColor: colors.grey_400,
      marginY: '6px',
    },
    topLeft: {
      top: VERTICAL_SPACE,
      bottom: 'auto',
      left: HORIZONTAL_SPACE,
      right: 'auto',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: VERTICAL_SPACE_MOBILE,
        left: HORIZONTAL_SPACE_MOBILE,
      },
    },
    topRight: {
      top: VERTICAL_SPACE,
      bottom: 'auto',
      right: HORIZONTAL_SPACE,
      left: 'auto',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: VERTICAL_SPACE_MOBILE,
        right: HORIZONTAL_SPACE_MOBILE,
      },
    },
    topCenter: {
      top: VERTICAL_SPACE,
      bottom: 'auto',
      right: '50%',
      transform: 'translateX(50%)',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: VERTICAL_SPACE_MOBILE,
      },
    },
    bottomLeft: {
      top: 'auto',
      bottom: VERTICAL_SPACE,
      left: HORIZONTAL_SPACE,
      right: 'auto',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        bottom: VERTICAL_SPACE_MOBILE,
        left: HORIZONTAL_SPACE_MOBILE,
      },
    },
    bottomRight: {
      top: 'auto',
      bottom: VERTICAL_SPACE,
      right: HORIZONTAL_SPACE,
      left: 'auto',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        bottom: VERTICAL_SPACE_MOBILE,
        right: HORIZONTAL_SPACE_MOBILE,
      },
    },
    bottomCenter: {
      top: 'auto',
      bottom: VERTICAL_SPACE,
      right: '50%',
      transform: 'translateX(50%)',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        bottom: VERTICAL_SPACE_MOBILE,
      },
    },
  };
};
